import React, { useEffect } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { createActorContext } from '@xstate/react'
import multiCartMachine from './multiCartMachine'
import { ActorRefFrom } from 'xstate'
import { useHistory } from 'react-router-dom'

// Cart machine is not needed at server side, initialise with server side state at client side, similar to redux.

export const MultiCartContext = createActorContext(multiCartMachine)

interface ReduxConnectedCartProviderProps {
  children: React.ReactNode
}

// Global reference to cart machine actor for Redux middleware access
let globalCartMachineActor: ActorRefFrom<typeof multiCartMachine> | null = null

export function getCartMachineActor() {
  return globalCartMachineActor
}

// Component to capture the actor reference
function CartMachineActorRegistry({ children }: { children: React.ReactNode }) {
  const actor = MultiCartContext.useActorRef()

  useEffect(() => {
    globalCartMachineActor = actor
    return () => {
      globalCartMachineActor = null
    }
  }, [actor])

  // Development-only state change logging
  useEffect(() => {
    if (actor) {
      // const subscription = actor.subscribe((snapshot) => {
      //   console.group('🛒 MultiCart Machine State Change')
      //   console.log('State:', snapshot.value)
      //   console.log('Context:', snapshot.context)
      //   console.log('Can:', snapshot.can)
      //   console.groupEnd()
      //   window.__DEBUG_MACHINE_CONTEXT__ = snapshot.context
      // })

      // return () => {
      //   subscription.unsubscribe()
      // }
    }
  }, [actor])

  return <>{children}</>
}

export function MultiCartMachineProvider({ children }: ReduxConnectedCartProviderProps) {
  const memberId = useAppSelector((state: App.State) => state.auth.account.memberId)
  const flags = useAppSelector((state: App.State) => state.system.features.flags)
  const history = useHistory()
  const currentRegionCode = useAppSelector((state: App.State) => state.geo.currentRegionCode)

  if (!flags[OptimizelyFeatureFlags.croSharedCarts]) {
    return <>{children}</>
  }

  return (
    <MultiCartContext.Provider options={{ input: { memberId, history, currentRegionCode } }}>
      <CartMachineActorRegistry>
        {children}
      </CartMachineActorRegistry>
    </MultiCartContext.Provider>
  )
}
